import React, { useState, useEffect } from "react";
import '../../styles/Dashboard.css'; // Optional, for styling
import Swal from 'sweetalert2';

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [text_search, setTextSearch] = useState(''); // Initial empty string for search field
  const [clientIDText, setClientIDText] = useState(''); // Holds the client ID
  const [isVisible, setIsVisible] = useState(false);

  // Handle input change
  const handleChangeSearch = (event) => {
    setTextSearch(event.target.value);
  };

  // Handle form submit
  const handleSubmit = (event) => {
    event.preventDefault();
    if (!text_search.trim()) {
      Swal.fire({
        title: "Searching...",
        text: "Please enter a valid Client ID or Contact ID",
        showConfirmButton: true,
        confirmButtonColor: '#A5CC2D', 
        willClose: () => {}, // optional callback
      });
      setIsVisible(false); // Show loading data section
      return;
    }
    setClientIDText(text_search); // Update clientIDText on submit
    //setLoading(true); // Set loading to true when starting the fetch request
    Swal.fire({
      title: "Searching...",
      text: `Searching Client ID / Contact ID: ${text_search}`,
      timer: 1500,
      showConfirmButton: false,
      willClose: () => {}, // optional callback
    });
    
  };

  //Fetch data when the clientIDText changes
  useEffect(() => {
    if (clientIDText === '') return; // Don't make the API call if the search text is empty
    
    const fetchData = async () => {
      
      try {
        setIsVisible(true); // Show loading data section
        const [validateRes] = await Promise.all([
          fetch(`https://eoeaecp10dceaok.m.pipedream.net/api/CompletionCalculator/ValidateClient?search_value=${clientIDText}`)
        ]);

         if (!validateRes.ok) {
          throw new Error("Failed to fetch data");
        }

        const validateData = await validateRes.json();
        setData(validateData);


      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "We're unable to get the data.",
          text: "Kindly contact PDR Support for assistance.",
          confirmButtonColor: '#A5CC2D', 
        });
      } finally {
      }

      setIsVisible(false); // Show loading data section
    };

    fetchData();
    
  }, [clientIDText]); // Trigger API call when clientIDText changes

  return (
    <div className="dashboard">
      {/* Display fetched data */}
      <div className="flex-container">

        <div className="column">
          <label className="container-title">Total Modules</label>
          {isVisible && (<span className="spinner"></span>)}
          <label className="container-count"  id="contact-id">{data.ContactID || '0'}</label>
        </div>
        
        <div className="column">
          <label className="container-title">Active Modules</label>
          {isVisible && (<span className="spinner"></span>)}
          <label className="container-count" id="client-id">
            {data.ClientID || '0'}
          </label> {/* Fallback if data not loaded */}
        </div>

        <div className="column">
          <label className="container-title">Under Maintenance Modules</label>
          {isVisible && (<span className="spinner"></span>)}
          <label className="container-count" id="external-id">
            {data.ExternalID || '0'}
          </label>
        </div>

        <div className="column">
          <label className="container-title">Deactivated Modules</label>
          {isVisible && (<span className="spinner"></span>)}
          <label className="container-count" id="external-id">
            {data.ExternalID || '0'}
          </label>
        </div>

      </div>
    </div>
  );
};

export default Dashboard;
